export default __webpack_public_path__ + "static/media/quick2s.8b00cd3e.svg";